import "../../styles/auth/verifyOtp.css";

const OtpInput = (props = {}) => {
  const { otp, setOtp, inputsRef, verifying, resending } = props;

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pasted)) return;

    const newOtp = pasted.split("");
    setOtp([...newOtp, ...Array(6 - newOtp.length).fill("")]);

    inputsRef.current[Math.min(newOtp.length, 5)]?.focus();
  };
  return (
    <label className="label-row">
      <div>
        OTP <p className="red-text">*</p>
      </div>
      <div className="otp-container" onPaste={handlePaste}>
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            maxLength={1}
            className="otp-input"
            value={digit}
            disabled={verifying || resending}
            ref={(el) => (inputsRef.current[index] = el)}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            placeholder="-"
          />
        ))}
      </div>
    </label>
  );
};

export default OtpInput;
